// extracted by mini-css-extract-plugin
export default {"cards":"page-events_cards__4dIKJ"};